import { useReactiveVar } from '@apollo/client';
import envConfig from '@hulu/env-config';
import { useContext, useRef, useState } from 'react';

import useGetBellNotificationStatus from '../../apis/graphql/notifications/useBellNotiticationStatus';
import { ReactComponent as UnreadBell } from '../../assets/images/bell.svg';
import { ReactComponent as Bell } from '../../assets/images/bellGreen.svg';
import { userAmsUserIdVar } from '../../constants';
import { GlobalPermissionsContext } from '../../context';
import { useOnClickOutside } from '../../hooks';
import HeaderFlyout from '../../pages/Notifications/HeaderFlyout/HeaderFlyout';
import { BellWrapper, StyledContent, StyledWrapper } from './styled';

const BellComponent = (): JSX.Element => {
  const userId = useReactiveVar(userAmsUserIdVar) || '';
  const [isNotificationsOpen, setIsNotificationsOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);
  const notificationRefetchInterval = +envConfig.REACT_APP_REFETCH_NOTIFICATION_INTERVAL;
  const { total } = useGetBellNotificationStatus(userId, notificationRefetchInterval);
  const { READ_NOTIFICATION } = useContext(GlobalPermissionsContext).permissions;

  useOnClickOutside(ref, () => setIsNotificationsOpen(false));

  const openNotificationList = (): void => {
    if (!READ_NOTIFICATION) return;

    setIsNotificationsOpen(!isNotificationsOpen);
  };

  return (
    <StyledWrapper ref={ref}>
      <BellWrapper data-testid="notificationBell" disabled={!READ_NOTIFICATION} onClick={openNotificationList}>
        {total ? <UnreadBell /> : <Bell />}
      </BellWrapper>
      {isNotificationsOpen && (
        <StyledContent>
          <HeaderFlyout onClose={(): void => setIsNotificationsOpen(false)} total={total} />
        </StyledContent>
      )}
    </StyledWrapper>
  );
};

export default BellComponent;
